import styled, {css} from 'styled-components'
import {PageCardWrapper} from '@/components/ui/page-atoms/PageAtoms'

// Standard settings-page card (same pattern as Referring Specialists):
// grid rows = heading / tabs / scrollable content. Single internal scroll
// container — nested scroll areas previously hid the filter accordions.
export const StyledCardWrapper = styled(PageCardWrapper)(
    () => css`
        overflow-y: hidden;
    `
)

export const StyledTabContent = styled.div`
    overflow-y: auto;
    min-height: 0;
`

export const StyledHeadingTexts = styled.div`
    ${({theme}) => css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing * 0.5}px;
    `}
`

// Portal target for MailerComposeTab's banner + send/test CTAs, so they can
// live next to the page title instead of at the bottom of the compose form.
// Single row: banner (if any) on the left, CTAs pinned to the right edge.
// Fixed min-height (banner pill height, taller than the buttons) keeps the
// CTAs vertically centered at the same spot whether or not a banner is shown.
export const StyledHeaderActionsSlot = styled.div`
    ${({theme}) => css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: ${theme.spacing * 3}px;
        min-height: 36px;
    `}
`
